import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface ConfirmationData {
  mensaje: string;
  imagen?: string;
  tipo?: 'success' | 'error' | 'info' | 'warning';
}

@Injectable({
  providedIn: 'root',
})
export class ConfirmationService {
  private confirmationSubject = new Subject<ConfirmationData>();
  public confirmation$ = this.confirmationSubject.asObservable();

  private promiseResolve: ((result: boolean) => void) | null = null;

  /**
   * Muestra el modal de confirmación y devuelve una promesa
   */
  confirm(data: ConfirmationData): Promise<boolean> {
    this.confirmationSubject.next(data);
    return new Promise<boolean>((resolve) => {
      this.promiseResolve = resolve;
    });
  }

  /**
   * Método interno para que el componente resuelva la promesa
   */
  setPromise(promise: Promise<boolean>) {
    promise.then((result) => {
      if (this.promiseResolve) {
        // ✅ Validamos que no sea null
        this.promiseResolve(result);
        this.promiseResolve = null; // ✅ Limpiamos
      }
    });
  }
}
